export const SHARING_PREVIEW_HEADER_HEIGHT = 42;
